//запрос id постов из ВК

export const WALLINDEX_REQUEST = 'WALLINDEX_REQUEST';
export const WALLINDEX_SUCCESS = 'WALLINDEX_SUCCESS';
export const WALLINDEX_FAIL = 'WALLINDEX_FAIL';


//удаление постов

export const WALLDELL_REQUEST = 'WALLDELL_REQUEST';
export const WALLDELL_SUCCESS = 'WALLDELL_SUCCESS';
export const WALLDELL_FAIL = 'WALLDELL_FAIL';
export const WALLDELL_TRIGGER = 'WALLDELL_TRIGGER'


//новая версия удаления постов
export const WALLDELL_START = 'WALLDELL_START';
export const WALLDELL_STOP = 'WALLDELL_STOP';
export const WALLDELL_WORK = 'WALLDELL_WORK';
export const WALLDELL_ERROR = 'WALLDELL_ERROR';



// WEBPACK FOOTER //
// ./src/constants/Wall.js